import { render, staticRenderFns } from "./ShowSeatsView.vue?vue&type=template&id=1da5415e"
import script from "./ShowSeatsView.vue?vue&type=script&lang=ts"
export * from "./ShowSeatsView.vue?vue&type=script&lang=ts"
import style0 from "./ShowSeatsView.vue?vue&type=style&index=0&id=1da5415e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports